module.exports = __webpack_public_path__ + "static/img/give_moeny_icon.7067c8c1.png";